module.exports = __webpack_public_path__ + "img/6.e26f0786.jpg";